export default {
  'operationLog.title': '后台操作日志',
  'operationLog.filter.timeRange': '操作时间',
  'operationLog.filter.loginName': '操作人账号',
  'operationLog.filter.loginNamePlaceholder': '请输入操作人账号',
  'operationLog.filter.menuId': '菜单',
  'operationLog.filter.menuIdPlaceholder': '请选择或输入菜单名称',
  'operationLog.menuNone': '无',
  'operationLog.filter.requestUrl': '接口路径',
  'operationLog.filter.requestUrlPlaceholder': '模糊匹配,例如 /user/mgmt',
  'operationLog.filter.requestMethod': '请求方式',
  'operationLog.filter.rsCode': '响应码',
  'operationLog.filter.clientIp': '客户端 IP',
  'operationLog.filter.serviceName': '服务名',
  'operationLog.filter.traceId': 'TraceId',
  'operationLog.filter.search': '查询',
  'operationLog.filter.reset': '重置',
  'operationLog.col.operationTime': '操作时间',
  'operationLog.col.loginName': '操作人账号',
  'operationLog.col.systemName': '操作人姓名',
  'operationLog.superAdmin': '超级管理员',
  'operationLog.col.menu': '菜单',
  'operationLog.col.serviceName': '服务',
  'operationLog.col.requestMethod': '方式',
  'operationLog.col.requestUrl': '接口路径',
  'operationLog.col.rsCode': '响应码',
  'operationLog.col.rsMessages': '响应消息',
  'operationLog.col.clientIp': '客户端 IP',
  'operationLog.col.durationMs': '耗时(ms)',
  'operationLog.col.traceId': 'TraceId',
  'operationLog.col.detail': '详情',
  'operationLog.detail.title': '操作日志详情',
  'operationLog.detail.basic': '基本信息',
  'operationLog.detail.userAgent': 'User-Agent',
  'operationLog.detail.requestParams': '请求参数',
  'operationLog.detail.responseSummary': '响应摘要',
  'operationLog.detail.exceptionMsg': '异常信息',
  'operationLog.fetchError': '查询失败,请稍后重试',
};
